import { render, staticRenderFns } from "./recordRegisterInfo.vue?vue&type=template&id=674a6cfc&"
import script from "./recordRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./recordRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports